/*
 * Delete-user.ts
 * Description: Includes the declaration
 * of the function for deleting a user
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Deleting a user
 *
 * @return {Object} Promise - when the request has been finished
 * @param {Number} id - id of the user
 */
export function deleteUser(id: number) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'users/' + id,
            method: 'delete',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
